export enum AppRoutes {
  HealthScreenList = '/crm/health-screen/list',
  HealthScreenDetail = '/crm/health-screen-detail/:id',
  OrganisationList = '/crm/organisation/list',
  TopicList = '/crm/topic/list',
  ResourceList = '/crm/resource/list',
  EventList = '/crm/events-list',
  EventDetail = '/crm/events/:id',
  BookingList = '/crm/bookings-list',
  BookingDetail = '/crm/booking-detail/:id',
  AppointmentSlotDetail = '/crm/appointment-slots/:id',
}
